/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryCountDto } from '../../models/create-inventory-count-dto';
import { InventoryCount } from '../../models/inventory-count';

export interface InventoryControllerCreate$Params {
      body: CreateInventoryCountDto
}

export function inventoryControllerCreate(http: HttpClient, rootUrl: string, params: InventoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryCount>> {
  const rb = new RequestBuilder(rootUrl, inventoryControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryCount>;
    })
  );
}

inventoryControllerCreate.PATH = '/inventory/counts';
